module.exports = __webpack_public_path__ + "img/220.278fb2a2.png";